var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.48266,
    y: 5.06908,
    width: 19.8621,
    height: 19.8621,
    rx: 9.93104,
    fill: "#FF7777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.48266,
    y: 5.06908,
    width: 19.8621,
    height: 19.8621,
    rx: 9.93104,
    stroke: "#E6E6E6",
    strokeWidth: 8.27586
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenRecord);
export default __webpack_public_path__ + "static/media/screen_record.e203c780c99199f4fbc158bc065331f4.svg";
export { ForwardRef as ReactComponent };